module.exports = __webpack_public_path__ + "img/turisme_rekreasjon_med_paavirkningsgrad.c4bf1a24.jpg";